import gql from 'graphql-tag';

export const GET_DEPENDENCY_SUB_TREE = gql`
  query getDependencySubTree($id: String!, $type: String!) {
    getDependencySubTree(id: $id, type: $type) {
      id
      parents
      type
      overrides
      hasLoop
    }
  }
`;
